import { Input, Image, Text, View, Tab } from 'components';
import Base, { Config } from 'components/saleTool/Base';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';
import { user } from 'modules/saleTool/store';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loading } from 'components/Modal';

interface State {
  id?: number;
  data: any;
  statusName:any;
  loading:boolean,
  page: number;
  type: number;
  isEnd: boolean
}

let lock = false;

export default class Accounts extends Base {
  public config: Config = {
    navigationBarTitleText: '全部账户管理'
  };

  public state: State = {
    data:[],
    statusName: ['管理员','销售','分拣员'],
    loading:false,
    page: 1,
    type: 0,
    isEnd: false,
  };

  public didMount() {
    this.getAccounts()

    let _this = this;
    window.addEventListener('scroll', (e) => {
        _this.handleScroll(e);
    });
  }

  private handleScroll = (e) => {
    // console.log(e)
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.body.scrollHeight-window.innerHeight
    if(height < 0){return;}
    if(scrollTop > height-10 && !this.state.isEnd && !lock){
      console.log("loading")
      lock = true;
      this.setState({
        page: this.state.page+1,
        loading:true
      },
      () => {
        this.getAccounts()
      })
    }
  }

  private showLoading = () => {
    this.setState({
      loading:true
    })
  }
  private hideLoading = () => {
    this.setState({
      loading:false
    })
  }

  private link = url => {
    history.push(url);
  }

  private toAdd = () => {
    this.link("/saleTool/AccountAdd")
  }

  private tabFun = (ind) => {
    console.log(ind)
    
    this.setState({
      type: ind,
      page: 1,
      data: []
    },()=>{
      this.getAccounts()
    })
    
  }

  private getAccounts = async() => {
    this.showLoading()
    const { page, type } = this.state;
    let da={}
    if(type > 0){
      da={page,type}
    }else{
      da={page}
    }
    const res = await this.apiClient.base.userListInfo(da)
    // console.log(res);

    if(res && res.status == 10000){

      if(JSON.stringify(res.body) == "{}"){return;}
      let result = [...this.state.data,...res.body];
      this.setState({
        data: result,
        isEnd: res.body.length == 0
      },() => {
        lock = false;
      })

    }else{
      toast.error(res.msg,{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
    }
    this.hideLoading()
  }

  private edit = (id) => {
    history.push('/saleTool/accountAdd',{id})
  }

  private delete = async(id) => {
    const res = await confirm("是否确定删除");
    if(!res){return;}
    this.showLoading()
    const response = await this.apiClient.base.userDelete({id});
    if(response.status == 10000){
      toast.info("删除成功！",{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      this.setState({
        page:1,
        data: [],
        isEnd: false
      },
      () => {
        this.getAccounts()
      })
      
    }else{
      toast.error(response.msg,{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    }
    this.hideLoading()
  }
  

  public render() {
    const { data, statusName, loading } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        <Loading isOpen={loading} />
        <Tab 
          opt={['全部账户','管理员','销售','分拣员']} 
          onClick={this.tabFun}
          className={styles.tabBox}
        />
        
        <View className={styles.main}>
          <View className={styles.list}>
            {data.map((option,index) => {
              return (
                <View className={styles.lis} key={index}>
                  <View className={styles.lis_l}>
                    <View className={styles.tit}>
                      <Text className={styles.name}>{option.name}</Text>
                      <Text className={styles.type}>{statusName[option.type-1]}</Text>
                    </View>
                    <Text className={styles.phone}>{option.phone}</Text>
                  </View>
                  <View className={styles.lis_r}>
                    <Text className={styles.delete} onClick={this.delete.bind(this,option.id)}>删除</Text>
                    <Text className={styles.change} onClick={this.edit.bind(this,option.id)}>修改</Text>
                  </View>
                </View>
              )
            })}
            
          </View>
          <View className={styles.buttonBox}>
              <Text className={styles.adminBtn} onClick={this.toAdd}>新增账户</Text>
          </View>
        </View>
      </View>
    );
  }
}
